module.exports = __webpack_public_path__ + "img/个人.c3079ee8.png";